// extracted by mini-css-extract-plugin
module.exports = {"attention":"R_dy"};